import hasOwn from 'object.hasown';

if (!Object.hasOwn) {
  hasOwn.shim();
}
